const state = {
    features: null
};
const actions = {
    setFeatures({ commit }, payload) {
        commit('updateFeatures', payload);
    }
};

const mutations = {
    updateFeatures(state, payload) {
        state.features = payload;
        
    }
};

export const featuresModule = {
    namespaced: true,
    state,
    actions,
    mutations
};
